// SafeModeSwitch.js
import { motion } from "framer-motion";
import { Check, X } from "lucide-react";
import clsx from "clsx";

export default function SafeModeSwitch({ enabled, onChange, loading = false }) {
  return (
    <button
      type="button"
      onClick={() => !loading && onChange(!enabled)}
      className={clsx(
        "relative w-10 h-6 flex items-center rounded-full transition-colors outline-none focus:ring-2 ring-[#01CC54]/40",
        enabled ? "bg-[#01CC54]" : "bg-gray-200 border border-gray-300",
        loading && "cursor-not-allowed opacity-60"
      )}
      aria-pressed={enabled}
      aria-label={enabled ? "Disable Safe Mode" : "Enable Safe Mode"}
      disabled={loading}
      tabIndex={0}
      style={{ minWidth: 40, minHeight: 24 }} // for pointer accuracy
    >
      <motion.span
        className="absolute inset-0 rounded-full pointer-events-none"
        initial={false}
        animate={{
          boxShadow: enabled
            ? "0 0 0 2px rgba(1,204,84,.25)"
            : "0 0 0 0 rgba(0,0,0,0)",
        }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
      />
      <motion.span
        className={clsx(
          "w-5 h-5 rounded-full shadow flex items-center justify-center bg-white",
          "z-10"
        )}
        layout
        transition={{ type: "spring", stiffness: 700, damping: 30 }}
        style={{
          x: enabled ? 20 : 0, // slides 20px as the toggle moves
        }}
      >
        {enabled ? (
          <Check size={14} className="text-[#01CC54]" />
        ) : (
          <X size={14} className="text-gray-500" />
        )}
      </motion.span>
    </button>
  );
}
